var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "panel" }, [
    _vm._m(0),
    _c("div", { staticClass: "panel-body" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-lg-5 col-md-6 col-12 pd-t5" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.newItem.orderTransactionCode,
                expression: "newItem.orderTransactionCode"
              }
            ],
            staticClass: "form-control",
            attrs: { type: "text", placeholder: "Mã vận đơn" },
            domProps: { value: _vm.newItem.orderTransactionCode },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(
                  _vm.newItem,
                  "orderTransactionCode",
                  $event.target.value
                )
              }
            }
          })
        ]),
        _c("div", { staticClass: "col-lg-5 col-md-6 col-12 pd-t5" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.newItem.productName,
                expression: "newItem.productName"
              }
            ],
            staticClass: "form-control",
            attrs: { type: "text", placeholder: "Tên sản phẩm" },
            domProps: { value: _vm.newItem.productName },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.newItem, "productName", $event.target.value)
              }
            }
          })
        ]),
        _c("div", { staticClass: "col-lg-2 col-md-6 col-12 pd-t5 mt10" }, [
          _c(
            "a",
            {
              staticClass: "text-danger",
              attrs: { href: "javascript: void(0)" },
              on: {
                click: function($event) {
                  return _vm.onAddTranCode()
                }
              }
            },
            [_c("i", { staticClass: "fa fa-plus" }), _vm._v(" Thêm mới")]
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "panel-heading" }, [
      _c("h4", { staticClass: "panel-title" }, [_vm._v("Thêm mã vận đơn")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }